import { Controller } from '@hotwired/stimulus'

// Auto-submits the host <form> when a control fires `submit-on-change#submit`
// (wired on the browse/genre filter selects). This makes the filter bar feel
// instant — pick a genre and the page reloads to that filtered, bookmarkable
// URL — while the GET form stays fully functional without JS (the <noscript>
// Apply button submits it the old-fashioned way). Auto-registered by the
// controllers glob.
export default class extends Controller {
  submit() {
    this.element.requestSubmit()
  }
}
